var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeMutualMatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeMutualMatch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.0113932,88 C26.9132895,88 28.8221699,88.7768797 30.2667571,90.3285262 L30.2667571,90.3285262 L31.9993794,92.1952772 L33.7320324,90.3383512 C36.6211761,87.2349921 41.3440292,87.2350613 44.2331423,90.3383512 C47.1222859,93.4416443 47.1222859,98.4257327 44.2331423,101.529029 L44.2331423,101.529029 L32.4397183,114.203286 C32.3239906,114.328856 32.1630079,114.4 31.9946008,114.4 C31.8261937,114.4 31.665211,114.328856 31.5494833,114.203286 L31.5494833,114.203286 L19.7656172,101.519188 C16.879782,98.4134899 16.8764737,93.431769 19.7656172,90.3285262 C21.2101738,88.7768765 23.1094969,88 25.0113932,88 Z M44.2998246,77.6 C45.1979423,77.6 46.099358,77.9531271 46.7815242,78.658421 L46.7815242,78.658421 L47.599707,79.5069442 L48.4179042,78.6628869 C49.782222,77.2522691 52.0124582,77.2523006 53.3767616,78.6628869 C54.7410795,80.0734747 54.7410795,82.3389694 53.3767616,83.7495586 C51.5201049,85.6692003 49.664287,87.5909856 47.8076448,89.5105843 C47.7529955,89.5676616 47.6769759,89.6 47.5974504,89.6 C47.5179248,89.6 47.4419052,89.5676616 47.387256,89.5105843 L47.387256,89.5105843 L41.8226526,83.7450855 C40.459897,82.3334045 40.4583348,80.0689859 41.8226526,78.658421 C42.5048043,77.9531257 43.4017069,77.6 44.2998246,77.6 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.9%",
    y: "-5.4%",
    width: "121.7%",
    height: "121.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc-Discover-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-profile-web-version-Copy",
    transform: "translate(-16.000000, -77.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icLikeMutualMatch"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeMutualMatch);
export default __webpack_public_path__ + "static/media/icLikeMutualMatch.b0c6ec3cce0a9e827703e84aaba2cead.svg";
export { ForwardRef as ReactComponent };